import styled from 'styled-components';

import PrimaryButton from '../../../../../../components/Button/ActionButtons/PrimaryButton';
import { TitleContainer } from '../../../../../../components/v2/Header';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const StartOverButton = styled(PrimaryButton)`
 font-size: 13px;
 padding: 12px 20px;
 font-weight: 500;
`;

const StyledTitleContainer = styled(TitleContainer)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

export {
  Container,
  StartOverButton,
  ButtonsContainer,
  StyledTitleContainer,
};
